import { apiCall } from './gqlClient';

const GETEXERCISES_QUERY = `
  query getExercises {
    getExercises
    {
      id
			providerId
			name
			description
			muscleArea
			level
			imageId
			videoId
			gifId
			gifThumbnailUrl
			imageThumbnailUrl
			videoThumbnailUrl
			muscleTargets
      ...fragments
    }
  }`;

export const getExercisesApiCall = async (fragments = null) => apiCall({ query: GETEXERCISES_QUERY, variables: {}, fragments });

const GETEXERCISESBYIDS_QUERY = `
  query getExercisesByIds($ids: [String]!) {
    getExercisesByIds(ids: $ids)
    {
      id
			providerId
			name
			description
			muscleArea
			level
			imageId
			videoId
			gifId
			gifThumbnailUrl
			imageThumbnailUrl
			videoThumbnailUrl
			muscleTargets
      ...fragments
    }
  }`;

export const getExercisesByIdsApiCall = async ({ids}, fragments = null) => apiCall({ query: GETEXERCISESBYIDS_QUERY, variables: {ids}, fragments });

const GETAIEXERCISES_QUERY = `
  query getAiExercises($levels: [String]!, $muscleAreas: [String]!) {
    getAiExercises(levels: $levels, muscleAreas: $muscleAreas)
    {
      id
			providerId
			name
			description
			muscleArea
			level
			imageId
			videoId
			gifId
			gifThumbnailUrl
			imageThumbnailUrl
			videoThumbnailUrl
			muscleTargets
      ...fragments
    }
  }`;

export const getAiExercisesApiCall = async ({levels, muscleAreas}, fragments = null) => apiCall({ query: GETAIEXERCISES_QUERY, variables: {levels, muscleAreas}, fragments });

const SAVEEXERCISE_QUERY = `
  mutation saveExercise($request: ExerciseInput!) {
    saveExercise(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const saveExerciseApiCall = async ({request}, fragments = null) => apiCall({ query: SAVEEXERCISE_QUERY, variables: {request}, fragments });

const DELETEEXERCISE_QUERY = `
  mutation deleteExercise($id: String!) {
    deleteExercise(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const deleteExerciseApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEEXERCISE_QUERY, variables: {id}, fragments });
